import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { jsPDF } from 'jspdf';
import theme from '../theme';

const LIMITE_ANNUALE = 5000;

function generaRicevuta(job, profile, session) {
  const doc = new jsPDF();
  const oggi = new Date().toLocaleDateString('it-IT');
  const nomeAutore = profile?.full_name || session?.user?.email;
  const isOra = job.proposed_price && job.hours_worked;
  const importoDettaglio = isOra
    ? `€${job.proposed_price}/h x ${job.hours_worked}h = €${job.amount_paid?.toFixed(2)}`
    : `€${job.amount_paid?.toFixed(2)} (importo fisso)`;

  doc.setFontSize(22);
  doc.setTextColor(45, 122, 58);
  doc.text('Jobbetty', 105, 20, { align: 'center' });

  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text('RICEVUTA DI PRESTAZIONE OCCASIONALE', 105, 32, { align: 'center' });

  doc.setLineWidth(0.5);
  doc.setDrawColor(45, 122, 58);
  doc.line(20, 38, 190, 38);

  doc.setFontSize(11);
  doc.text(`Data: ${oggi}`, 20, 50);
  doc.text(`Prestatore: ${nomeAutore}`, 20, 62);
  doc.text(`Email: ${session?.user?.email}`, 20, 74);

  doc.line(20, 82, 190, 82);

  doc.setFontSize(12);
  doc.setTextColor(45, 122, 58);
  doc.text('DETTAGLI PRESTAZIONE', 20, 94);

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.text(`Descrizione: ${job.jobs?.title || 'Prestazione occasionale'}`, 20, 106);
  doc.text(`Categoria: ${job.jobs?.category || '-'}`, 20, 118);
  doc.text(`Importo: ${importoDettaglio}`, 20, 130);
  doc.text(`Totale ricevuto: EUR ${job.amount_paid?.toFixed(2)}`, 20, 142);

  doc.line(20, 152, 190, 152);

  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text("Prestazione occasionale ai sensi dell'art. 2222 del Codice Civile.", 20, 166);
  doc.text("Compenso non soggetto a IVA. Soggetto a ritenuta d'acconto del 20%", 20, 176);
  doc.text("se il committente e' un sostituto d'imposta.", 20, 186);

  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('Firma del prestatore: ____________________', 20, 210);
  doc.text(`${nomeAutore}`, 20, 224);

  doc.setFontSize(9);
  doc.setTextColor(150, 150, 150);
  doc.text('Documento generato da Jobbetty', 105, 280, { align: 'center' });

  doc.save(`ricevuta_${job.jobs?.title?.replace(/\s+/g, '_') || 'lavoro'}_${oggi.replace(/\//g, '-')}.pdf`);
}

function Guadagni({ session, profile }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchJobs(); }, []);

  const fetchJobs = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('applications')
      .select('*, jobs(title, category)')
      .eq('applicant_email', session?.user?.email)
      .eq('status', 'accettata')
      .order('created_at', { ascending: false });
    if (data) setJobs(data);
    setLoading(false);
  };

  const anno = new Date().getFullYear();
  const guadagniAnno = jobs
    .filter(j => j.completed && new Date(j.created_at).getFullYear() === anno)
    .reduce((sum, j) => sum + (j.amount_paid || 0), 0);

  const percentuale = Math.min((guadagniAnno / LIMITE_ANNUALE) * 100, 100);
  const coloreBar = guadagniAnno >= 4500 ? theme.colors.error : guadagniAnno >= 3500 ? theme.colors.accent : theme.colors.primary;

  return (
    <div>
      <div style={{ background: theme.colors.background, borderRadius: theme.radius.lg, padding: theme.spacing.xl, marginBottom: theme.spacing.xl }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: theme.spacing.lg }}>
          <div>
            <div style={{ fontSize: theme.font.size.base, color: theme.colors.textMuted, marginBottom: 4 }}>Guadagnato nel {anno}</div>
            <div style={{ fontSize: 36, fontWeight: 700, color: coloreBar }}>€{guadagniAnno.toFixed(2)}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: theme.font.size.base, color: theme.colors.textMuted, marginBottom: 4 }}>Limite annuale</div>
            <div style={{ fontSize: theme.font.size.xl, fontWeight: 600, color: theme.colors.textPrimary }}>€{LIMITE_ANNUALE.toLocaleString()}</div>
          </div>
        </div>

        <div style={{ background: theme.colors.border, borderRadius: theme.radius.md, height: 12, marginBottom: 8 }}>
          <div style={{ background: coloreBar, borderRadius: theme.radius.md, height: 12, width: `${percentuale}%`, transition: 'width 0.5s' }} />
        </div>
        <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, textAlign: 'right' }}>{percentuale.toFixed(1)}% del limite annuale</div>

        {guadagniAnno >= 5000 && (
          <div style={{ background: theme.colors.errorBg, color: theme.colors.errorDark, padding: 12, borderRadius: theme.radius.md, marginTop: 12, fontSize: theme.font.size.base, lineHeight: 1.5 }}>
            🚨 <strong>Hai superato il limite di €5.000!</strong> Devi aprire la Partita IVA. Consulta un commercialista.
          </div>
        )}
        {guadagniAnno >= 4500 && guadagniAnno < 5000 && (
          <div style={{ background: theme.colors.warningBg, color: theme.colors.warning, padding: 12, borderRadius: theme.radius.md, marginTop: 12, fontSize: theme.font.size.base, lineHeight: 1.5 }}>
            ⚠️ <strong>Attenzione!</strong> Ti mancano solo €{(5000 - guadagniAnno).toFixed(2)} al limite annuale.
          </div>
        )}
        {guadagniAnno >= 3500 && guadagniAnno < 4500 && (
          <div style={{ background: theme.colors.warningBgSoft, color: theme.colors.warningText, padding: 12, borderRadius: theme.radius.md, marginTop: 12, fontSize: theme.font.size.base }}>
            💡 Tieni d'occhio il limite annuale di €5.000 per le prestazioni occasionali.
          </div>
        )}
        {guadagniAnno < 3500 && (
          <div style={{ background: theme.colors.primaryLight, color: theme.colors.primary, padding: 12, borderRadius: theme.radius.md, marginTop: 12, fontSize: theme.font.size.base }}>
            ✅ Sei nella norma per le prestazioni occasionali senza Partita IVA.
          </div>
        )}
      </div>

      <h3 style={{ margin: '0 0 12px', color: theme.colors.textPrimary, fontSize: theme.font.size.lg }}>Lavori accettati</h3>

      {loading && <p style={{ color: theme.colors.textMuted, textAlign: 'center' }}>Caricamento...</p>}
      {!loading && jobs.length === 0 && (
        <p style={{ color: theme.colors.textMuted, textAlign: 'center', marginTop: 20 }}>
          Nessun lavoro accettato ancora. Candidati a qualche annuncio!
        </p>
      )}

      {jobs.map(job => {
        const isOra = job.proposed_price && job.hours_worked;
        return (
          <div key={job.id} style={{ border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.lg, marginBottom: theme.spacing.md }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontWeight: 600, fontSize: theme.font.size.lg }}>{job.jobs?.title}</span>
              {job.completed && (
                <span style={{ color: theme.colors.primary, fontWeight: 700 }}>+€{job.amount_paid?.toFixed(2)}</span>
              )}
            </div>

            {job.completed && isOra && (
              <div style={{ fontSize: theme.font.size.sm, color: '#888', marginBottom: 6 }}>
                €{job.proposed_price}/h × {job.hours_worked}h = €{job.amount_paid?.toFixed(2)}
              </div>
            )}

            <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginBottom: 10 }}>
              {new Date(job.created_at).toLocaleDateString('it-IT')}
            </div>

            {job.completed ? (
              <div style={{ display: 'flex', gap: theme.spacing.sm, alignItems: 'center', flexWrap: 'wrap' }}>
                <span style={{ background: theme.colors.primaryLight, color: theme.colors.primary, padding: '3px 10px', borderRadius: theme.radius.md, fontSize: theme.font.size.sm }}>
                  ✅ Completato
                </span>
                <button
                  onClick={() => generaRicevuta(job, profile, session)}
                  style={{ background: theme.colors.primary, color: theme.colors.white, border: 'none', borderRadius: theme.radius.sm, padding: '5px 12px', cursor: 'pointer', fontSize: theme.font.size.sm }}>
                  📄 Scarica ricevuta
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.sm }}>
                <span style={{ background: theme.colors.warningBgSoft, color: theme.colors.warningText, padding: '3px 10px', borderRadius: theme.radius.md, fontSize: theme.font.size.sm }}>
                  ⏳ In corso
                </span>
                <span style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>Conferma il completamento dalla chat</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Guadagni;